import { RoundedRectangle } from "../atoms/roundedrectangle/RoundedRectangle"
import { Spacer } from "../atoms/Atoms"
import React from "react"
import L10n from "../../../lib/carrot-l10n"
import { RRIconBar } from "../atoms/roundedrectangle/RRIconBar"
import { BodySmall } from "../atoms/Bodies"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

export const CarrotExpertsModule = () => (
  <RoundedRectangle backgroundColor="light-gray">
    <RRIconBar iconName="icn-help" iconBackgroundColor="white" />
    <BodySmall color="black-60">{l`client.experts.details1`}</BodySmall>
    <Spacer height={1} />
    <BodySmall color="black-60">{l`client.experts.details2`}</BodySmall>
  </RoundedRectangle>
)
